import React from 'react';
import App from '../containers/App';
import { PartialRepayment } from '../containers/PartialRepayment';
import { config } from './config';

export const rootClass = () => {
  const { theme, inFrame } = config();
  return `App theme-${theme}` + ((inFrame) ? ' in-frame': '');
}

export const rootSelector = () => {
  if (document.getElementById("partial-repayment")) {
    return "partial-repayment";
  }
  return 'root';
}

export const rootComponent = () => {
  if (process.env.REACT_APP_PARTIAL_REPAYMENT || document.getElementById("partial-repayment")) {
    return (<div className={rootClass()}><PartialRepayment /></div>)
  }
  return (<App />);
}



// WEBPACK FOOTER //
// ./src/config/mount.js